if (!customElements.get('brand-directory')) {
  customElements.define('brand-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.renderDirectory();
      this.refreshBrands();
    }
    renderDirectory() {
      const groups = new Map();
      this.querySelectorAll('[data-brand-source] a[data-brand]').forEach(link => {
        const name = link.dataset.brand.trim();
        const key = name.toLocaleLowerCase();
        if (!groups.has(key)) groups.set(key, { name, categories: new Map() });
        const group = groups.get(key);
        const category = link.dataset.category;
        if (!group.categories.has(category)) group.categories.set(category, new URL(link.href));
        else {
          const url = group.categories.get(category);
          const value = new URL(link.href).searchParams.get('filter.p.m.custom.brand');
          if (!url.searchParams.getAll('filter.p.m.custom.brand').includes(value)) url.searchParams.append('filter.p.m.custom.brand', value);
        }
      });
      const container = this.querySelector('[data-directory]');
      const alphabet = this.querySelector('.km-alphabet');
      container.replaceChildren();alphabet.replaceChildren();
      const letters = new Set();
      [...groups.values()].sort((a,b)=>a.name.localeCompare(b.name, 'en', {sensitivity:'base'})).forEach(group => {
        const details = document.createElement('details');
        details.dataset.name = group.name.toLocaleLowerCase();
        details.id = 'brand-' + group.name.toLocaleLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
        const summary = document.createElement('summary');
        summary.textContent = group.name;
        const icon = document.createElement('span'); icon.textContent = '+'; icon.setAttribute('aria-hidden','true'); summary.append(icon); details.append(summary);
        group.categories.forEach((url,category)=>{const a=document.createElement('a');a.href=url.href;a.textContent=category;details.append(a)});
        container.append(details);
        const first = group.name[0].toUpperCase(); const letter = /[A-Z]/.test(first) ? first : '#';
        if (!letters.has(letter)) {letters.add(letter);const a=document.createElement('a');a.href='#'+details.id;a.textContent=letter;alphabet.append(a)}
      });
      if (groups.size) this.querySelector('[data-brand-source]').hidden = true;
      const filter = () => {
        const term=this.querySelector('input').value.trim().toLocaleLowerCase();let count=0;
        container.querySelectorAll('details').forEach(item=>{item.hidden=!item.dataset.name.includes(term);if(!item.hidden)count++});
        this.querySelector('[data-brand-count]').textContent=count+' brands';
        this.querySelector('[data-brand-empty]').hidden=count>0;
      };
      this.querySelector('input').oninput=filter;filter();
      if(location.hash){const target=document.getElementById(decodeURIComponent(location.hash.slice(1)));if(target?.tagName==='DETAILS'){target.open=true;target.scrollIntoView({block:'center'})}}
    }
    async refreshBrands() {
      const handles=["cleansers","toners-essences","serums-ampoules","moisturizers","face-masks","sunscreen-spf","eye-lip-care","makeup","hair-care","body-care","skincare-sets-kits"];
      const key='keiray-brand-facets:'+this.dataset.country;
      try {
        const cached=JSON.parse(sessionStorage.getItem(key)||'null');
        if(cached&&Date.now()-cached.time<300000){this.mergeSources(cached.html);return}
      } catch (_) {}
      const results=[];
      // Bound concurrent requests. Each response contains facet links, never products.
      const queue=[...handles];
      const worker=async()=>{while(queue.length){const handle=queue.shift();try{const root=this.dataset.root.replace(/\/$/,'');const response=await fetch(root+'/collections/'+handle+'?section_id=keiray-brand-source');if(response.ok)results.push(await response.text())}catch(_){}}};
      await Promise.all([worker(),worker(),worker()]);
      const html=results.join('');this.mergeSources(html);
      try{sessionStorage.setItem(key,JSON.stringify({time:Date.now(),html}))}catch(_){}
    }
    mergeSources(html) {
      const documentFragment=new DOMParser().parseFromString(html,'text/html');
      const source=this.querySelector('[data-brand-source]');
      documentFragment.querySelectorAll('a[data-brand][data-category]').forEach(link=>source.append(link));
      this.renderDirectory();
    }
  });
}